import React, { useRef, useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../propTypes";
import { withStyles } from "@material-ui/core";
import { calculateChartHeight } from "./CountryExplorer";
import AreaChooser from "../choosers/AreaChooser";
import CountryExplorerChartTitle from "./CountryExplorerChartTitle";
import CountryExplorerProjectionChart from "./CountryExplorerProjectionChart";
import MethodChooser from "../choosers/MethodChooser";
import Switch from "../widgets/Switch";

const styles = {
  content: {
    margin: `4rem 0`
  },
  switchButton: {
    width: "6rem",
    fontSize: "1rem",
    padding: "4px 0"
  },
  toolbar: {
    width: "100%",
    margin: "2rem 0 2rem 1rem",
    paddingRight: "2rem",
    display: "flex",
    alignItems: "center"
  },
  toolbarItem: {
    margin: "0 15px",
    display: "inline-block"
  }
};

const getChangeDetails = (indicatorId, gniGroupId, methodId) => ({
  widget: "countryExplorer.projectionChart",
  payload: {
    indicator: indicatorId,
    gniGroup: gniGroupId,
    method: methodId
  }
});

const CountryExplorerProjectionChartWidget = props => {
  const [indicatorId, setIndicatorId] = useState(4);
  const [areaId, setAreaId] = useState(14);
  const [methodId, setMethodId] = useState();

  const ref = useRef();

  return (
    <div>
      <CountryExplorerChartTitle
        database={props.database}
        indicatorId={indicatorId}
        areaId={areaId}
        methodId={methodId}
        fileStem="country_explorer_projection_chart"
        includeSectorSetting={false}
        chartRef={ref}
      >
        Explore Future Changes
      </CountryExplorerChartTitle>

      <p>
        The graph below shows data by country for countries within the selected
        GNI group. Explore this data using the dropdowns and toggles below.
      </p>

      <div className={props.classes.toolbar}>
        <div className={props.classes.toolbarItem}>
          <Switch
            onText="Users"
            offText="Costs"
            checked={indicatorId === 4}
            buttonClassName={props.classes.switchButton}
            onToggle={() => {
              const id = indicatorId === 4 ? 6 : 4;

              setIndicatorId(id);

              props.onChange(getChangeDetails(id, areaId, methodId));
            }}
          />
        </div>

        <div className={props.classes.toolbarItem}>
          <AreaChooser
            id="country-explorer-projection-chart-area"
            label="GNI Group"
            areas={props.database.areas}
            onlyShowIncomeLevels={true}
            selectedKey={areaId}
            onChange={id => {
              setAreaId(id);

              props.onChange(getChangeDetails(indicatorId, id, methodId));
            }}
          />
        </div>

        <div className={props.classes.toolbarItem}>
          <MethodChooser
            id="country-explorer-projection-chart-method"
            label="Method"
            methods={props.database.methods}
            selectedKey={methodId}
            allowMix={false}
            onChange={id => {
              setMethodId(id);

              props.onChange(getChangeDetails(indicatorId, areaId, id));
            }}
          />
        </div>
      </div>

      <div className={props.classes.chart}>
        <CountryExplorerProjectionChart
          ref={ref}
          data={props.data}
          height={calculateChartHeight(1000, props.data.length / 9)}
          indicator={indicatorId === 4 ? "Users" : "Costs"}
        />
      </div>
    </div>
  );
};

CountryExplorerProjectionChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array,
  onChange: PropTypes.func.isRequired
};

export default withStyles(styles)(CountryExplorerProjectionChartWidget);
